export enum EModalType {
  LOGIN = 'login',
  SIGN_UP = 'signup',
  RESET = 'reset',
  TERMS = 'terms',
  NOT_VERIFIED = 'notVerified',
}
